import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/products/categories",
    name: "product-categories",
    component: () => import("../presentation/pages/Categories.vue"),
    meta: {
      layout: "default",
      public: false,
      action: "list",
      subject: "category",
    },
  },
  {
    path: "/products/vendors",
    name: "product-vendors",
    component: () => import("../presentation/pages/Vendors.vue"),
    meta: {
      layout: "default",
      public: false,
      action: "list",
      subject: "vendor",
    },
  },
  {
    path: "/products/all/devices",
    name: "all-devices",
    component: () => import("../presentation/pages/AllDevices.vue"),
    meta: {
      layout: "default",
      public: false,
      action: "list_all",
      subject: "device",
    },
  },
  {
    path: "/products/all/batches",
    name: "all-batches",
    component: () => import("../presentation/pages/AllBatches.vue"),
    meta: {
      layout: "default",
      public: false,
      action: "list_all",
      subject: "batch",
    },
  },
  {
    path: "/products/devices",
    name: "product-devices",
    component: () => import("../presentation/pages/Devices.vue"),
    meta: {
      layout: "default",
      public: false,
      action: "list",
      subject: "device",
    },
  },
  {
    path: "/products/devices/:id",
    name: "product-device-details",
    component: () => import("../presentation/pages/DeviceDetails.vue"),
    meta: {
      layout: "default",
      public: false,
      action: "view",
      subject: "device",
    },
  },
  {
    path: "/products",
    name: "products-list",
    component: () => import("../presentation/pages/Products.vue"),
    meta: {
      layout: "default",
      public: false,
      action: "list",
      subject: "product",
    },
  },
  {
    path: "/products/batches",
    name: "product-batches",
    component: () => import("../presentation/pages/Batches.vue"),
    meta: {
      layout: "default",
      public: false,
      action: "list",
      subject: "batch",
    },
  },
  {
    path: "/products/batches/:id",
    name: "batch-details",
    component: () => import("../presentation/pages/BatchDetails.vue"),
    meta: {
      layout: "default",
      public: false,
      action: "view",
      subject: "batch",
    },
  },
  {
    path: "/products/:id",
    name: "product-details",
    component: () => import("../presentation/pages/ProductDetails.vue"),
    meta: {
      layout: "default",
      public: false,
      action: "view",
      subject: "product",
    },
  },
];
